import { Text } from "lucide-react";
import React from "react";

export default function NotFoundPage({appName = ""}) {
  const colors = {
    background: "#0f172a",
    accent: "#38bdf8",
    text: "#ffffff",
    buttonBg: "#ffffff",
    buttonText: "#0f172a",
  };

  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: colors.background,
        color: colors.text,
        textAlign: "center",
        padding: "20px",
      }}
    >
      <b>{appName}</b>
      <div>
        <h1
          style={{
            fontSize: "120px",
            margin: 0,
            fontWeight: "900",
            color: colors.accent,
          }}
        >
          404
        </h1>

        <h2
          style={{
            fontSize: "32px",
            marginTop: "10px",
          }}
        >
          Page Not Found
        </h2>

        <p
          style={{
            fontSize: "16px",
            opacity: 0.8,
            maxWidth: "450px",
            lineHeight: "1.6",
            margin: "15px auto",
          }}
        >
          Sorry, the page you are looking for doesn't exist or has been moved.
        </p>

        <button
          onClick={() => window.history.back()}
          style={{
            marginTop: "20px",
            padding: "12px 30px",
            border: `2px solid ${colors.buttonBg}`,
            borderRadius: "999px",
            background: colors.buttonBg,
            color: colors.buttonText,
            fontWeight: "600",
            fontSize: "15px",
            cursor: "pointer",
            transition: "0.3s",
          }}
        >
          Go Back
        </button>
      </div>        
    </div>
  );
}